
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { AuthData } from '@/models/auth';

@Component({
  components: {},
  computed: {
    ...mapState('moduleAuthData', ['authData']),
  },
})
export default class CustomerCodeSelect extends Vue {
  @Prop({ type: Boolean, required: false }) public readonly disabled!: boolean;
  @Prop({ type: Boolean, required: false }) public readonly required!: boolean;
  @Prop({ type: String, required: false }) private readonly chosen!: string;

  private authData: AuthData;
  public selectedCustomerCode = '';
  public get availableCustomerCodes(): string[] {
    return this.authData?.availableCustomerCodes || [];
  }

  @Watch('chosen')
  private setChosen() {
    if (this.selectedCustomerCode !== this.chosen) {
      this.selectedCustomerCode = this.chosen;
      this.$emit('change', this.selectedCustomerCode);
    }
  }

  public setChosenCustomerCode(customerCode: string) {
    if (!customerCode) {
      this.selectedCustomerCode = '';
      this.$emit('clear', '');
    } else {
      this.selectedCustomerCode = customerCode;
      this.$emit('change', this.selectedCustomerCode);
    }
  }
}
